<template>
  <div
    class="service-info row no-gutters justify-content-between align-items-start py-2"
  >
    <router-link
      :to="`/service/${service.id}`"
      class="row no-gutters align-items-center flex-nowrap col-12 col-lg-4 pr-2"
    >
      <div class="col-auto pl-2 pl-md-4 svg-lg text-primary">
        <LabIcon v-if="service.category_id === 'laboratory'"></LabIcon>
        <DiagnosticsIcon
          v-if="service.category_id === 'diagnostics'"
        ></DiagnosticsIcon>
        <OnlineConsultationIcon
          v-if="service.category_id === 'consultation'"
        ></OnlineConsultationIcon>
      </div>
      <div class="col pl-3 mb-2">
        <small v-if="service.category_id" class="text-muted">
          {{ $t(service.category_id) }}
        </small>
        <h4 v-if="service">
          {{ service.name[authLocale] }}
        </h4>
      </div>
    </router-link>
    <div class="col">
      <div class="row no-gutters mb-3">
        <router-link
          :to="`/service/${service.id}?service=${s.id}`"
          v-for="s of service.clinic_services"
          :key="s.id"
          class="col p-3 text-left shadow-sm shadow-hover m-2 service-item pointer text-primary"
          :class="{
            'current shadow': clinicServiceId === s.id,
          }"
        >
          <!-- 'current shadow': clinic_serviceIndex === i, -->
          <!-- @click.prevent="clinic_serviceIndex = i" -->
          <div class="row no-gutters mb-2 flex-nowrap">
            <div class="col pr-3">
              <div class="icon mb-2">
                <online-consultation-icon
                  v-if="s.type === 'telemedicine'"
                ></online-consultation-icon>
                <clinic-icon v-else-if="s.type === 'visit'"></clinic-icon>
                <ambulance-icon
                  v-else-if="s.type === 'house_call'"
                ></ambulance-icon>
              </div>
              <small>{{ $t(s.type) }}</small>
            </div>
            <div class="col">
              <div class="h-100 d-flex flex-wrap">
                <h1 class="text-right mb-0 align-self-start w-100">₾</h1>
                <strong class="d-block text-right align-self-end w-100">
                  {{ Math.round(s.price / 100).toFixed(2) }}
                </strong>
              </div>
            </div>
          </div>
          <!-- <small
            class="d-block mb-2 text-center"
            :class="{
              'text-primary': clinic_service_id === s.id,
              'text-muted': clinic_service_id !== s.id,
            }"
          >
            {{ s.name[authLocale] }}
            <span v-if="s.name_addition">
              ({{ s.name_addition[authLocale] }})
            </span>
          </small> -->
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import OnlineConsultationIcon from '@/components/Icons/OnlineConsultation'
import ClinicIcon from '@/components/Icons/Clinic'
import AmbulanceIcon from '@/components/Icons/Ambulance'
import LabIcon from '@/components/Icons/Lab'
import DiagnosticsIcon from '@/components/Icons/Diagnostics'
export default {
  components: {
    OnlineConsultationIcon,
    ClinicIcon,
    AmbulanceIcon,
    LabIcon,
    DiagnosticsIcon
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    clinicServiceId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      scheduleByDoctorAndService: 'schedule/byDoctorAndService'
    })
  },
  methods: {
    checkSchedule (service_id) {
      const schedules = this.scheduleByDoctorAndService(
        this.service.id,
        service_id
      )
      if (schedules.length > 0) {
        for (const s of schedules) {
          if (
            this.$moment(s.start_time).diff(this.$moment().startOf('day')) > 0
          ) {
            return true
          }
        }
        // this.clinic_serviceIndex = i
        return true
      }
      return false
    }
  }
}
</script>
<style lang="scss">
.service-info {
  svg {
    width: 36px;
  }
  .svg-lg {
    svg {
      width: 75px;
      height: 75px;
    }
  }
  .avatar {
    width: 100px;
    height: 100px;
    border-radius: 50px;
    &.doconline {
      border: 3px solid #28a745;
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "laboratory": "ლაბორატორია",
      "diagnostics": "დიაგნოსტიკა",
      "telemedicine": "ონლაინ",
      "visit": "კლინიკაში",
      "house_call": "გამოძახება",
      "laboratory": "ლაბორატორია",
      "diagnostics": "დიაგნოსტიკა"
  },
  "en": {
      "laboratory": "Laboratory",
      "diagnostics": "Diagnostics",
      "telemedicine": "Online",
      "visit": "At Clinic",
      "house_call": "House Call",
      "laboratory": "Laboratory",
      "diagnostics": "Diagnostics"
  }
}
</i18n>
